<template>
  <div id="course-reporting-widget">

    <div id="widgetPopupTarget">
      <span style="visibility: hidden;">_^_</span>
    </div>

    <div id="widgetPopover"></div>

    <b-popover container="widgetPopover" target="widgetPopupTarget" triggers="click" :show.sync="showWidgetPopover" :placement="'left'" style="max-width: 700px !important;">
      <div class="row" style="background: #eaf8ff; height: 50px; margin-top: -8px;">
        <div class="col-12" style="margin-top: 0.5rem;">
          <div class="popup-header">
            <div class="close_btn_container">
              <button class="btn_close" aria-label="close" @click="closeWidgetPopup">
                <span class="ic-close"></span>
              </button>
            </div>
            <div class="popup_hd">
              <span>Add Completed Courses to Save Time and Money</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isClientVerified">
        <template v-if="isAuthenticated">
          <template v-if="isLoadAddedCourseList">
            <self-reported-course-list ref="reportedCourseList" :is-loading-on-widget="true"></self-reported-course-list>
          </template>
        </template>
        <template v-else>
          <div class="text-center" style="margin-top: 40px;">
            <h3>You are not authorized. Please contact your administrator.</h3>
          </div>
        </template>
      </div>
    </b-popover>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import '../assets/theme/default/sass/global.scss'
  //import '../assets/theme/default/css/defaultTheme.min.css'
  import '../assets/module/css/explore/explore.min.css'
  import SelfReportedCourseList from './transfer/components/SelfReportedCourseList'
  import { StorageFactory } from '../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'course-reporting-widget-app',
    components: {
      SelfReportedCourseList
    },
    data: () => {
      return {
        key: null,
        secret: null,
        userId: null,
        firstName: null,
        lastName: null,
        institutionId: null,
        isAuthenticated: false,
        isClientVerified: false,
        showWidgetPopover: false,
        showAddCoursePopover: false,
        isLoadAddedCourseList: false,
        isGuestLogin: (localStore.getItem('userrole') === 'Guest')
      }
    },
    mounted () {
      if (this.$route.query) {
        this.key = this.$route.query.key
        this.secret = this.$route.query.secret
        this.userId = this.$route.query.userId
        this.authenticateWidget()
        window.addEventListener('message', (event) => {
          if (event.data.name === 'PostLogin') {
            let data = event.data.data
            this.userId = data.userId
            this.firstName = data.firstName
            this.lastName = data.lastName
            setTimeout(() => {
              window.parent.postMessage({name: 'ShowWidgetPopover'}, '*')
              this.isLoadAddedCourseList = true
              this.showWidgetPopover = true
              this.loadLoginUser()
            }, 500)
          }
        })
      }
    },
    methods: {
      ...mapActions([
        'loadAuthenticateWidget',
        'loadLoginCourseReportingWidgetUser'
      ]),
      closeWidgetPopup () {
        window.parent.postMessage({name: 'HideWidgetPopover'}, '*')
        this.showWidgetPopover = false
      },
      async authenticateWidget () {
        this.institutionId = await this.loadAuthenticateWidget({key: this.key, secret: this.secret, type: 'COURSE_REPORTING'})
        if (this.institutionId) {
          this.isClientVerified = true
          this.isAuthenticated = true
          this.loadLoginUser()
        } else {
          this.isAuthenticated = false
        }
      },
      async loadLoginUser () {
        let data = {
          userId: this.userId,
          firstName: this.firstName,
          lastName: this.lastName
        }
        let userObj = await this.loadLoginCourseReportingWidgetUser({institutionId: this.institutionId, data: data})
        if (userObj && userObj.uuid) {
          let role = userObj.roles[0].role
          this.isGuestLogin = (role === 'Guest')
          let addCourseClicked = localStore.getItem('AddCourseClicked')
          if (addCourseClicked) {
            localStore.removeItem('AddCourseClicked')
            setTimeout(() => {
              this.$refs.reportedCourseList.addCourseFromWidget()
            }, 500)
          }
        }
      }
    }
  }
</script>

<style>
  #widgetPopover:before {
    content: ' ';
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2;
  }
  .popup_hd {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    color: rgb(40, 40, 40);
  }
  .close_btn_container {
    position: absolute;
    top: 2px;
    right: 20px;
  }
  .course-reporting-widget .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 700px !important;
    width: 700px !important;
    height: 600px !important;
    font-family: Avenir, sans-serif !important;
    font-size: 14px;
    .arrow {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/CourseReportingWidgetApp.vue